import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "cloud_32",
  "use": "cloud_32-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"cloud_32\"><path d=\"M16 7a7.66 7.66 0 011.51.15 8 8 0 016.35 6.34l.26 1.35 1.35.24a5.5 5.5 0 01-1 10.92H7.5a5.5 5.5 0 01-1-10.92l1.34-.24.26-1.35A8 8 0 0116 7m0-2a10 10 0 00-9.83 8.12A7.5 7.5 0 007.49 28h17a7.5 7.5 0 001.32-14.88 10 10 0 00-7.94-7.94A10.27 10.27 0 0016 5z\" /><path style=\"fill:none\" d=\"M0 0h32v32H0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol